import React from "react";

import styles from "./styles.module.css";

interface LoaderProps {
    blur?: boolean;
    wrapperClassName?: string;
}

const Loader: React.FC<LoaderProps> = ({ blur = false, wrapperClassName = "" }) => {
    return (
        <div className={`${wrapperClassName || styles.wrapper} ${blur ? styles.blurEffect : ""}`}>
            <div className={styles.summaryLoaderWrapper}>
                <div className={styles.loaderAnimation}></div>
                <div className={styles.loaderAnimation}></div>
                <div className={styles.loaderAnimation}></div>
                <div className={styles.loaderAnimation}></div>
                <div className={styles.loaderAnimation}></div>
            </div>
        </div>
    );
};

export default Loader;
